import { useMemo } from 'react';
import { ImageStyle, StyleProp } from 'react-native';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { MBSeparator } from '@shared/components/list';
import { MBTextBody2, MBTextOverlineBold } from '@shared/components/typography';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';

export interface MBSeenByListProps {
  seen: API.ShortUserFragment[];
  notSeen: API.ShortUserFragment[];
  keyword: string;
}

const userImageStyle: StyleProp<ImageStyle> = {
  width: 24,
  height: 24,
  borderRadius: 12,
  overflow: 'hidden',
};

export function MBSeenByList({ seen, notSeen, keyword }: MBSeenByListProps) {
  const seenList = useMemo(() => {
    return seen.filter(user => user.fullName.toLowerCase().includes(keyword.toLowerCase()));
  }, [seen, keyword]);

  const notSeenList = useMemo(() => {
    return notSeen.filter(user => user.fullName.toLowerCase().includes(keyword.toLowerCase()));
  }, [notSeen, keyword]);

  return (
    <View>
      <View
        paddingHorizontal={2}
        paddingTop={3}
        paddingBottom={2}
        style={{ backgroundColor: 'white' }}
      >
        <View paddingBottom={2}>
          <MBTextOverlineBold color={Colors.v2.gray50}>
            {i18n('chat.seenBySheet.seen', { count: seenList.length })}
          </MBTextOverlineBold>
        </View>
        {seenList.map((user, index) => (
          <View key={index} row centerVertically paddingBottom={1}>
            <MBUserImage size="small" user={user} style={userImageStyle} />
            <View paddingRight={1} />
            <View flex marginRight={1}>
              <MBTextBody2>{user.fullName}</MBTextBody2>
            </View>
          </View>
        ))}
      </View>
      <View paddingHorizontal={2}>
        <MBSeparator />
      </View>
      <View paddingHorizontal={2} flex paddingVertical={3}>
        <View paddingBottom={2}>
          <MBTextOverlineBold color={Colors.v2.gray50}>
            {i18n('chat.seenBySheet.notSeen', { count: notSeenList.length })}
          </MBTextOverlineBold>
        </View>
        {notSeenList.map((user, index) => (
          <View key={index} row centerVertically paddingBottom={1}>
            <MBUserImage size="small" user={user} style={userImageStyle} />
            <View paddingRight={1} />
            <View flex marginRight={1}>
              <MBTextBody2>{user.fullName}</MBTextBody2>
            </View>
            <MBTextBody2 color={Colors.v2.gray50}>
              {i18n('chat.seenBySheet.notSeenLabel')}
            </MBTextBody2>
          </View>
        ))}
      </View>
    </View>
  );
}
